import { IDefineCommand } from 'core-ts-types';
import { FeedbackSuggestedPlanModel } from '../models/feedback_suggested_plan_model';

angular
  .module('capability-ng-academic-planner')
  .service(
    'changeSuggestedPlanStatusCommand',
    function changeSuggestedPlanStatusCommand(
      $http: ng.IHttpService,
      log: any,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      defineCommand: IDefineCommand
    ) {
      return defineCommand('changeSuggestedPlanStatusCommand', (deferred: any, status: string) => {
        const suggestedPlanId = ngFeedbackSuggestedPlanModel.read().id;
        $http
          .put(`/academicplan/suggested_plan/${suggestedPlanId}`, {
            status: status.toUpperCase()
          })
          .then((response: any) => {
            deferred.resolve(response);
          })
          .catch((error: any) => {
            log.disable();
            deferred.reject(error);
            log.enable();
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/commands/change_suggested_plan_status_command.ts